
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic03Off as ObiHydraulic03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-03-off.js';
 
 
 

 
 export const ObiHydraulic03Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-03-off',
   elementClass: ObiHydraulic03OffElement,
   events: {
     
   }
  });
 
 